import { useRecoilState } from 'recoil'
import { useDeleteAccountMutation } from '../api/client'
import useQueryParams from '../hooks/useQueryParams'
import { shouldRefetchAccountsState } from '../store/UIStore'
import ConfirmModal from './ConfirmModal'

type Props = {
    setVisible: (visible: boolean) => void
    accountId: number
    onDeleted?: () => void
}

function DeleteAccountModal(props: Props) {
    const { setVisible, accountId, onDeleted } = props

    /* eslint-disable @typescript-eslint/no-unused-vars */
    const [shouldRefetchAccounts, setShouldRefetchAccounts] = useRecoilState(
        shouldRefetchAccountsState
    )

    const [deleteAccountMutation, { loading }] = useDeleteAccountMutation({
        onCompleted: () => {
            setShouldRefetchAccounts(true)
        }
    })

    const query = useQueryParams()
    let authCode: string

    const state = query.get('state')

    //facebook
    if (state) {
        authCode = query.get('code')!
    }

    const deleteAccountAction = async () => {
        await deleteAccountMutation({
            variables: {
                accountId: accountId,
                authCode: authCode
            },
        })
    }

    async function handleDeleteClick() {
        await deleteAccountAction()
        onDeleted?.()
        setVisible(false)
    }

    return (
        <ConfirmModal
            open={true}
            onClose={() => setVisible(false)}
            onConfirm={handleDeleteClick}
            title="Delete account"
            description="Are you sure you want to delete this account? This action cannot be undone."
            confirmLabel="Delete"
            loading={loading}
        />
    )
}

export default DeleteAccountModal
